import { z } from "zod";

import { McpServerImplementationSchema } from "./McpServerImplementation.schema";

/**
 * `McpServer.initializeResult` — the server's MCP `initialize` result from its last
 * successful sync, verbatim minus `_meta` and `instructions`.
 *
 * UNTRUSTED end to end: every string is server-authored.
 *
 * `instructions` is REFUSED here, not merely absent. It is text a server writes for a
 * model to read, so it lives in `McpServer.discoveredInstructions` and reaches a model
 * only once approved. A copy in this column would be the one nobody approved.
 *
 * `capabilities` is kept as an opaque record: which capabilities exist is the
 * protocol's to grow, and a reader asks for the one it needs.
 *
 * No `_v`: this is the protocol's object, versioned by `protocolVersion` — the
 * exception `ProviderHandshake/payload/__json.schema.ts` documents.
 */
export const McpServerInitializeResultSchema = z.looseObject({
  protocolVersion: z.string(),
  capabilities: z.record(z.string(), z.unknown()),
  serverInfo: McpServerImplementationSchema,
  instructions: z.undefined()
});

export type McpServerInitializeResult = z.infer<typeof McpServerInitializeResultSchema>;
